import StatisticsModal from './StatisticsModal';

export default StatisticsModal;
